import React from "react";
import { Box, Typography, Paper, Link } from "@mui/material";
import { useLanguage } from "../LanguageContext";

interface PublicationItem {
  title: string;
  file: string; // PDF file path
}

const publicationsData: PublicationItem[] = [
  {
    title: "Játék és társadalom - Absztraktkötet",
    file: "/files/jatek_es_tarsadalom_abstract.pdf",
  },
  {
    title: "Kultúratudományi Szemle 2025",
    file: "/files/kulturatudomanyi_szemle_2025.pdf",
  },
  {
    title: "Play and Society Conference Proceedings 2025",
    file: "/files/pas_pre3.pdf",
  },
];

export default function PublicationsWall() {
  const { language } = useLanguage();

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f7f7f7",
        padding: { xs: 2, md: 4 },
      }}
    >
      <Typography
        variant="h3"
        sx={{
          marginBottom: "30px",
          fontWeight: "bold",
          textAlign: "center",
          color: "#cc0000",
        }}
      >
        {language === "en" ? "Publications" : "Publikációk"}
      </Typography>

      {publicationsData.map((item, index) => (
        <Paper
          key={index}
          elevation={2}
          sx={{
            padding: 3,
            marginBottom: 3,
            backgroundColor: "white",
            borderLeft: "5px solid #cc0000",
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 1 }}>
            <Link
              href={item.file}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={{ color: "#cc0000" }}
            >
              {item.title}
            </Link>
          </Typography>
        </Paper>
      ))}
    </Box>
  );
}
